// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProblemDetailsPopup-module__font-s-10___cilpE {
  font-size: 10px !important;
}

.ProblemDetailsPopup-module__font-s-12___ob6yE {
  font-size: 12px !important;
}

.ProblemDetailsPopup-module__font-s-13___DlQOe {
  font-size: 13px !important;
}

.ProblemDetailsPopup-module__font-s-14____vT03 {
  font-size: 14px !important;
}

.ProblemDetailsPopup-module__font-s-15___sjKk1 {
  font-size: 15px !important;
}

.ProblemDetailsPopup-module__font-s-16___C5MWa {
  font-size: 16px !important;
}

.ProblemDetailsPopup-module__font-s-18___ST7bf {
  font-size: 18px !important;
}

.ProblemDetailsPopup-module__font-s-20____65kv {
  font-size: 20px !important;
}

.ProblemDetailsPopup-module__font-s-22___Ta6Ov {
  font-size: 22px !important;
}

.ProblemDetailsPopup-module__font-s-28___mu5hu {
  font-size: 28px !important;
}

.ProblemDetailsPopup-module__font-w-400___v32oI {
  font-weight: 400 !important;
}

.ProblemDetailsPopup-module__font-w-500___sPoXW {
  font-weight: 500 !important;
}

.ProblemDetailsPopup-module__font-w-600___jskvK {
  font-weight: 600 !important;
}

.ProblemDetailsPopup-module__font-w-700___xLo4q {
  font-weight: 700 !important;
}

.ProblemDetailsPopup-module__p-5___roIxA {
  padding: 5px !important;
}

.ProblemDetailsPopup-module__p-12___LbLe0 {
  padding: 12px !important;
}

.ProblemDetailsPopup-module__p-16___ThU9j {
  padding: 16px !important;
}

.ProblemDetailsPopup-module__p-30___dkIfc {
  padding: 30px !important;
}

.ProblemDetailsPopup-module__p-b-0___QZjcy {
  padding-bottom: 0 !important;
}

.ProblemDetailsPopup-module__p-b-5___gwdfg {
  padding-bottom: 5px !important;
}

.ProblemDetailsPopup-module__p-b-10___SfZA_ {
  padding-bottom: 10px !important;
}

.ProblemDetailsPopup-module__p-b-12___rzhS2 {
  padding-bottom: 12px !important;
}

.ProblemDetailsPopup-module__p-b-16___ubz1e {
  padding-bottom: 16px !important;
}

.ProblemDetailsPopup-module__p-b-18___wMbSW {
  padding-bottom: 18px !important;
}

.ProblemDetailsPopup-module__p-b-20___je5Nl {
  padding-bottom: 20px !important;
}

.ProblemDetailsPopup-module__p-b-25___BFf2q {
  padding-bottom: 25px !important;
}

.ProblemDetailsPopup-module__p-b-30___UfTi6 {
  padding-bottom: 30px !important;
}

.ProblemDetailsPopup-module__p-b-50___snRaf {
  padding-bottom: 50px !important;
}

.ProblemDetailsPopup-module__p-t-0___nt1d4 {
  padding-top: 0 !important;
}

.ProblemDetailsPopup-module__p-t-12___EIDUa {
  padding-top: 12px !important;
}

.ProblemDetailsPopup-module__p-t-16___eeFcd {
  padding-top: 16px !important;
}

.ProblemDetailsPopup-module__p-t-18___rqMRB {
  padding-top: 18px !important;
}

.ProblemDetailsPopup-module__p-t-20___kSJRi {
  padding-top: 20px !important;
}

.ProblemDetailsPopup-module__p-t-30___Gz_AG {
  padding-top: 30px !important;
}

.ProblemDetailsPopup-module__p-t-40___K8FU6 {
  padding-top: 40px !important;
}

.ProblemDetailsPopup-module__p-t-50___kVQLd {
  padding-top: 50px !important;
}

.ProblemDetailsPopup-module__p-l-20___xiB5s {
  padding-left: 20px !important;
}

.ProblemDetailsPopup-module__p-l-30___mgl8s {
  padding-left: 30px !important;
}

.ProblemDetailsPopup-module__p-l-40___ZjCgz {
  padding-left: 40px !important;
}

.ProblemDetailsPopup-module__p-r-16___C_the {
  padding-right: 16px !important;
}

.ProblemDetailsPopup-module__p-r-20___aIEFG {
  padding-right: 20px !important;
}

.ProblemDetailsPopup-module__p-r-30___wH2tS {
  padding-right: 30px !important;
}

.ProblemDetailsPopup-module__p-r-50___lHUPo {
  padding-right: 50px !important;
}

.ProblemDetailsPopup-module__p-r-60___Q7GXa {
  padding-right: 60px !important;
}

.ProblemDetailsPopup-module__m-b-1____9LEJ {
  margin-bottom: 1px !important;
}

.ProblemDetailsPopup-module__m-b-2___DeQhz {
  margin-bottom: 2px !important;
}

.ProblemDetailsPopup-module__m-b-6___COrgk {
  margin-bottom: 6px !important;
}

.ProblemDetailsPopup-module__m-b-8___RJOgY {
  margin-bottom: 8px !important;
}

.ProblemDetailsPopup-module__m-b-10___pH8lp {
  margin-bottom: 10px !important;
}

.ProblemDetailsPopup-module__m-b-14___xaghn {
  margin-bottom: 14px !important;
}

.ProblemDetailsPopup-module__m-b-16___bBAs9 {
  margin-bottom: 16px !important;
}

.ProblemDetailsPopup-module__m-b-20___YkbZm {
  margin-bottom: 20px !important;
}

.ProblemDetailsPopup-module__m-b-22___L_znO {
  margin-bottom: 22px !important;
}

.ProblemDetailsPopup-module__m-b-24___hvPaT {
  margin-bottom: 24px !important;
}

.ProblemDetailsPopup-module__m-b-30___weIXC {
  margin-bottom: 30px !important;
}

.ProblemDetailsPopup-module__m-b-32___JZlxv {
  margin-bottom: 32px !important;
}

.ProblemDetailsPopup-module__m-b-40___GkKc3 {
  margin-bottom: 40px !important;
}

.ProblemDetailsPopup-module__m-t-2___MkW_J {
  margin-top: 2px !important;
}

.ProblemDetailsPopup-module__m-t-3___KC9x3 {
  margin-top: 3px !important;
}

.ProblemDetailsPopup-module__m-t-4___yGzAh {
  margin-top: 4px !important;
}

.ProblemDetailsPopup-module__m-t-5___VNJa7 {
  margin-top: 5px !important;
}

.ProblemDetailsPopup-module__m-t-8___oMkG5 {
  margin-top: 8px !important;
}

.ProblemDetailsPopup-module__m-t-10___HV_YS {
  margin-top: 10px !important;
}

.ProblemDetailsPopup-module__m-t-15___Yx_YU {
  margin-top: 15px !important;
}

.ProblemDetailsPopup-module__m-t-16___KkJ_o {
  margin-top: 16px !important;
}

.ProblemDetailsPopup-module__m-t-20___wCynX {
  margin-top: 20px !important;
}

.ProblemDetailsPopup-module__m-t-22___Qy0Ln {
  margin-top: 22px !important;
}

.ProblemDetailsPopup-module__m-t-30___cMGP8 {
  margin-top: 30px !important;
}

.ProblemDetailsPopup-module__m-t-32___qz7xU {
  margin-top: 32px !important;
}

.ProblemDetailsPopup-module__m-l-auto___tVM0q {
  margin-left: auto !important;
}

.ProblemDetailsPopup-module__m-l-4___WxsHu {
  margin-left: 4px !important;
}

.ProblemDetailsPopup-module__m-l-5____Fsi4 {
  margin-left: 5px !important;
}

.ProblemDetailsPopup-module__m-l-6___bGtWM {
  margin-left: 6px !important;
}

.ProblemDetailsPopup-module__m-l-8___LHKeP {
  margin-left: 8px !important;
}

.ProblemDetailsPopup-module__m-l-10___HRq_4 {
  margin-left: 10px !important;
}

.ProblemDetailsPopup-module__m-l-16___rsvAv {
  margin-left: 16px !important;
}

.ProblemDetailsPopup-module__m-l-20___sVHsX {
  margin-left: 20px !important;
}

.ProblemDetailsPopup-module__m-l-24___BGAKc {
  margin-left: 24px !important;
}

.ProblemDetailsPopup-module__m-l-30___XCu2U {
  margin-left: 30px !important;
}

.ProblemDetailsPopup-module__m-l-35___Ywg4l {
  margin-left: 35px !important;
}

.ProblemDetailsPopup-module__m-l-40___Dc4Cc {
  margin-left: 40px !important;
}

.ProblemDetailsPopup-module__m-r-8___gsIe3 {
  margin-right: 8px !important;
}

.ProblemDetailsPopup-module__m-r-10___mYjly {
  margin-right: 10px !important;
}

.ProblemDetailsPopup-module__m-r-16___Q2_jH {
  margin-right: 16px !important;
}

.ProblemDetailsPopup-module__m-r-20___FylX_ {
  margin-right: 20px !important;
}

.ProblemDetailsPopup-module__m-r-24___rKRd0 {
  margin-right: 24px !important;
}

.ProblemDetailsPopup-module__m-r-30___hP4GF {
  margin-right: 30px !important;
}

.ProblemDetailsPopup-module__m-r-40____N6Ni {
  margin-right: 40px !important;
}

.ProblemDetailsPopup-module__border-r-3___CiyWF {
  border-radius: 3px !important;
}

.ProblemDetailsPopup-module__border-r-4___uiDCJ {
  border-radius: 4px !important;
}

.ProblemDetailsPopup-module__border-r-6___TLLDh {
  border-radius: 6px !important;
}

.ProblemDetailsPopup-module__border-r-10___UFtAd {
  border-radius: 10px !important;
}

.ProblemDetailsPopup-module__border-r-12___gx776 {
  border-radius: 12px !important;
}

.ProblemDetailsPopup-module__border-r-16___jWrFG {
  border-radius: 16px !important;
}

.ProblemDetailsPopup-module__border-r-50___wF7QM {
  border-radius: 50% !important;
}

.ProblemDetailsPopup-module__primary-border___arrr9 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ProblemDetailsPopup-module__primary-border-b___HdKm5 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ProblemDetailsPopup-module__primary-border-t___EMIvD {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ProblemDetailsPopup-module__primary-border-l____g1Se {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ProblemDetailsPopup-module__primary-border-r___TYQSd {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ProblemDetailsPopup-module__secondary-border___Pp3Md {
  border: 1px solid #637768;
}

.ProblemDetailsPopup-module__secondary-border-b___OVJ6U {
  border-bottom: 1px solid #637768;
}

.ProblemDetailsPopup-module__secondary-border-t___NqKca {
  border-top: 1px solid #637768;
}

.ProblemDetailsPopup-module__secondary-border-l___o2pGW {
  border-left: 1px solid #637768;
}

.ProblemDetailsPopup-module__secondary-border-r___YFpi6 {
  border-right: 1px solid #637768;
}

.ProblemDetailsPopup-module__gap-0___G0BGs {
  gap: 0 !important;
}

.ProblemDetailsPopup-module__gap-2___nY0uU {
  gap: 2px !important;
}

.ProblemDetailsPopup-module__gap-4___A5DbK {
  gap: 4px !important;
}

.ProblemDetailsPopup-module__gap-5___JkVk_ {
  gap: 5px !important;
}

.ProblemDetailsPopup-module__gap-6___WvqHk {
  gap: 6px !important;
}

.ProblemDetailsPopup-module__gap-8___q1wJA {
  gap: 8px !important;
}

.ProblemDetailsPopup-module__gap-10___msx_P {
  gap: 10px !important;
}

.ProblemDetailsPopup-module__gap-12___fwNwh {
  gap: 12px !important;
}

.ProblemDetailsPopup-module__gap-14___uIYD4 {
  gap: 14px !important;
}

.ProblemDetailsPopup-module__gap-16___Nqqz8 {
  gap: 16px !important;
}

.ProblemDetailsPopup-module__gap-18___zysHP {
  gap: 18px !important;
}

.ProblemDetailsPopup-module__gap-20___PGdK6 {
  gap: 20px !important;
}

.ProblemDetailsPopup-module__gap-24___c7FL1 {
  gap: 24px !important;
}

.ProblemDetailsPopup-module__gap-26___Bcqv_ {
  gap: 26px !important;
}

.ProblemDetailsPopup-module__gap-30___BWFSP {
  gap: 30px !important;
}

.ProblemDetailsPopup-module__gap-32___pjqYm {
  gap: 32px !important;
}

.ProblemDetailsPopup-module__gap-40___J1NWl {
  gap: 40px !important;
}

.ProblemDetailsPopup-module__gap-50___U7ddj {
  gap: 50px !important;
}

.ProblemDetailsPopup-module__flex-1___lS0bQ {
  flex: 1;
}

.ProblemDetailsPopup-module__flex-none___FH5_o {
  flex: none !important;
}

.ProblemDetailsPopup-module__flex-column___CkW7y {
  display: flex;
  flex-direction: column !important;
}

.ProblemDetailsPopup-module__flex-row___LGGHX {
  display: flex;
  flex-direction: row !important;
}

.ProblemDetailsPopup-module__vertically-centered___iOlp9 {
  display: flex;
  align-items: center !important;
}

.ProblemDetailsPopup-module__horizontally-centered___RVgV7 {
  display: flex;
  justify-content: center !important;
}

.ProblemDetailsPopup-module__horizontally-end___FDjsz {
  display: flex;
  justify-content: end !important;
}

.ProblemDetailsPopup-module__vertically-start___r13O9 {
  display: flex;
  align-items: start !important;
}

.ProblemDetailsPopup-module__space-between___LOh00 {
  display: flex;
  justify-content: space-between !important;
}

.ProblemDetailsPopup-module__flex-wrap___I_pm9 {
  flex-wrap: wrap !important;
}

.ProblemDetailsPopup-module__height-100___yM5LZ {
  height: 100%;
}

.ProblemDetailsPopup-module__width-50___eXAQI {
  width: 50% !important;
}

.ProblemDetailsPopup-module__width-100___HOxfw {
  width: 100%;
}

.ProblemDetailsPopup-module__cursor-pointer___vN_WB {
  cursor: pointer;
}

.ProblemDetailsPopup-module__cursor-not-allowed___hJWSk {
  cursor: not-allowed !important;
}

.ProblemDetailsPopup-module__absolute-centered___biWBC {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ProblemDetailsPopup-module__absolute___n2fXu {
  position: absolute;
}

.ProblemDetailsPopup-module__relative___XbfDz {
  position: relative;
}

.ProblemDetailsPopup-module__fixed___OGIT_ {
  position: fixed;
}

.ProblemDetailsPopup-module__visible___drTiW {
  opacity: 1;
}

.ProblemDetailsPopup-module__invisible___z0Iqv {
  opacity: 0;
}

.ProblemDetailsPopup-module__col-90____eikw {
  width: 90% !important;
}

.ProblemDetailsPopup-module__col-auto___BDxHD {
  width: auto !important;
}

.ProblemDetailsPopup-module__medical-tabs___wdscy {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ProblemDetailsPopup-module__medical-table-new___itCZ6 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ProblemDetailsPopup-module__medical-table-new___itCZ6:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ProblemDetailsPopup-module__medical-table-new___itCZ6::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ProblemDetailsPopup-module__medical-table-new___itCZ6::-webkit-scrollbar-track {
  display: none;
}
.ProblemDetailsPopup-module__medical-table-new___itCZ6.ProblemDetailsPopup-module__no-pagination___OWkPo {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ProblemDetailsPopup-module__medical-table-new___itCZ6.ProblemDetailsPopup-module__no-pagination___OWkPo:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ProblemDetailsPopup-module__medical-table-new___itCZ6.ProblemDetailsPopup-module__no-pagination___OWkPo::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ProblemDetailsPopup-module__medical-table-new___itCZ6.ProblemDetailsPopup-module__no-pagination___OWkPo::-webkit-scrollbar-track {
  display: none;
}

.ProblemDetailsPopup-module__medical-table-empty___OWjQX {
  padding: 14px 40px !important;
}

.ProblemDetailsPopup-module__icon-btn___s8pu3 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ProblemDetailsPopup-module__search-icon___SbnLZ {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ProblemDetailsPopup-module__disable-select___VX6WJ {
  user-select: none;
}

.ProblemDetailsPopup-module__break-word___OmI88 {
  word-break: break-word;
}

.ProblemDetailsPopup-module__popup-clear-btn___emmdc {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ProblemDetailsPopup-module__scroll-m-b-20___wxyG9 {
  scroll-margin-bottom: 20px;
}

.ProblemDetailsPopup-module__padding___LL3kf, .ProblemDetailsPopup-module__itemsRow___F_03h .ProblemDetailsPopup-module__item___9kdRl {
  padding: 5px 30px 20px 30px;
}

.ProblemDetailsPopup-module__titleContainer___Itx3g {
  flex: 1;
  justify-content: space-between;
  padding: 17px 30px;
}
.ProblemDetailsPopup-module__titleContainer___Itx3g .ProblemDetailsPopup-module__textContainer___AugbP {
  flex: 1;
}
.ProblemDetailsPopup-module__titleContainer___Itx3g .ProblemDetailsPopup-module__textContainer___AugbP .ProblemDetailsPopup-module__titleText___MIVcJ {
  max-width: 78%;
  font-family: var(--font-family);
  font-weight: 700;
  color: #375844;
  line-height: 27px;
}
.ProblemDetailsPopup-module__titleContainer___Itx3g .ProblemDetailsPopup-module__textContainer___AugbP .ProblemDetailsPopup-module__icd10Text___keXHz {
  display: flex;
  line-height: 150%;
  color: #859989;
}

.ProblemDetailsPopup-module__itemsRow___F_03h {
  display: flex;
  width: 100%;
}
.ProblemDetailsPopup-module__itemsRow___F_03h .ProblemDetailsPopup-module__item___9kdRl {
  width: 25%;
}

.ProblemDetailsPopup-module__separator___CKkVs {
  height: 1px;
  width: 100%;
  background-color: rgba(91, 91, 91, 0.2);
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/ProblemDetailsPopup/ProblemDetailsPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,2BAAA;AA8pBF;;AA3pBA;EACE,OAAA;EACA,8BAAA;EACA,kBAAA;AA8pBF;AA5pBE;EACE,OAAA;AA8pBJ;AA5pBI;EACE,cAAA;EEWJ,+BApBO;EAqBP,gBCtBK;EHYD,cAAA;EACA,iBAAA;AA+pBN;AA5pBI;EACE,aAAA;EACA,iBAAA;EACA,cAAA;AA8pBN;;AAzpBA;EACE,aAAA;EACA,WAAA;AA4pBF;AA1pBE;EACE,UAAA;AA4pBJ;;AAvpBA;EACE,WAAA;EACA,WAAA;EACA,uCAAA;AA0pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.padding {\n  padding: 5px 30px 20px 30px;\n}\n\n.titleContainer {\n  flex: 1;\n  justify-content: space-between;\n  padding: 17px 30px;\n\n  .textContainer {\n    flex: 1;\n\n    .titleText {\n      max-width: 78%;\n      @include get-font($roboto, $bold);\n      color: get-color(greenNew, dark);\n      line-height: 27px;\n    }\n\n    .icd10Text {\n      display: flex;\n      line-height: 150%;\n      color: get-color(greenNew, medium);\n    }\n  }\n}\n\n.itemsRow {\n  display: flex;\n  width: 100%;\n\n  .item {\n    width: 25%;\n    @extend .padding;\n  }\n}\n\n.separator {\n  height: 1px;\n  width: 100%;\n  background-color: rgba(91, 91, 91, 0.2);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ProblemDetailsPopup-module__font-s-10___cilpE`,
	"fontS12": `ProblemDetailsPopup-module__font-s-12___ob6yE`,
	"fontS13": `ProblemDetailsPopup-module__font-s-13___DlQOe`,
	"fontS14": `ProblemDetailsPopup-module__font-s-14____vT03`,
	"fontS15": `ProblemDetailsPopup-module__font-s-15___sjKk1`,
	"fontS16": `ProblemDetailsPopup-module__font-s-16___C5MWa`,
	"fontS18": `ProblemDetailsPopup-module__font-s-18___ST7bf`,
	"fontS20": `ProblemDetailsPopup-module__font-s-20____65kv`,
	"fontS22": `ProblemDetailsPopup-module__font-s-22___Ta6Ov`,
	"fontS28": `ProblemDetailsPopup-module__font-s-28___mu5hu`,
	"fontW400": `ProblemDetailsPopup-module__font-w-400___v32oI`,
	"fontW500": `ProblemDetailsPopup-module__font-w-500___sPoXW`,
	"fontW600": `ProblemDetailsPopup-module__font-w-600___jskvK`,
	"fontW700": `ProblemDetailsPopup-module__font-w-700___xLo4q`,
	"p5": `ProblemDetailsPopup-module__p-5___roIxA`,
	"p12": `ProblemDetailsPopup-module__p-12___LbLe0`,
	"p16": `ProblemDetailsPopup-module__p-16___ThU9j`,
	"p30": `ProblemDetailsPopup-module__p-30___dkIfc`,
	"pB0": `ProblemDetailsPopup-module__p-b-0___QZjcy`,
	"pB5": `ProblemDetailsPopup-module__p-b-5___gwdfg`,
	"pB10": `ProblemDetailsPopup-module__p-b-10___SfZA_`,
	"pB12": `ProblemDetailsPopup-module__p-b-12___rzhS2`,
	"pB16": `ProblemDetailsPopup-module__p-b-16___ubz1e`,
	"pB18": `ProblemDetailsPopup-module__p-b-18___wMbSW`,
	"pB20": `ProblemDetailsPopup-module__p-b-20___je5Nl`,
	"pB25": `ProblemDetailsPopup-module__p-b-25___BFf2q`,
	"pB30": `ProblemDetailsPopup-module__p-b-30___UfTi6`,
	"pB50": `ProblemDetailsPopup-module__p-b-50___snRaf`,
	"pT0": `ProblemDetailsPopup-module__p-t-0___nt1d4`,
	"pT12": `ProblemDetailsPopup-module__p-t-12___EIDUa`,
	"pT16": `ProblemDetailsPopup-module__p-t-16___eeFcd`,
	"pT18": `ProblemDetailsPopup-module__p-t-18___rqMRB`,
	"pT20": `ProblemDetailsPopup-module__p-t-20___kSJRi`,
	"pT30": `ProblemDetailsPopup-module__p-t-30___Gz_AG`,
	"pT40": `ProblemDetailsPopup-module__p-t-40___K8FU6`,
	"pT50": `ProblemDetailsPopup-module__p-t-50___kVQLd`,
	"pL20": `ProblemDetailsPopup-module__p-l-20___xiB5s`,
	"pL30": `ProblemDetailsPopup-module__p-l-30___mgl8s`,
	"pL40": `ProblemDetailsPopup-module__p-l-40___ZjCgz`,
	"pR16": `ProblemDetailsPopup-module__p-r-16___C_the`,
	"pR20": `ProblemDetailsPopup-module__p-r-20___aIEFG`,
	"pR30": `ProblemDetailsPopup-module__p-r-30___wH2tS`,
	"pR50": `ProblemDetailsPopup-module__p-r-50___lHUPo`,
	"pR60": `ProblemDetailsPopup-module__p-r-60___Q7GXa`,
	"mB1": `ProblemDetailsPopup-module__m-b-1____9LEJ`,
	"mB2": `ProblemDetailsPopup-module__m-b-2___DeQhz`,
	"mB6": `ProblemDetailsPopup-module__m-b-6___COrgk`,
	"mB8": `ProblemDetailsPopup-module__m-b-8___RJOgY`,
	"mB10": `ProblemDetailsPopup-module__m-b-10___pH8lp`,
	"mB14": `ProblemDetailsPopup-module__m-b-14___xaghn`,
	"mB16": `ProblemDetailsPopup-module__m-b-16___bBAs9`,
	"mB20": `ProblemDetailsPopup-module__m-b-20___YkbZm`,
	"mB22": `ProblemDetailsPopup-module__m-b-22___L_znO`,
	"mB24": `ProblemDetailsPopup-module__m-b-24___hvPaT`,
	"mB30": `ProblemDetailsPopup-module__m-b-30___weIXC`,
	"mB32": `ProblemDetailsPopup-module__m-b-32___JZlxv`,
	"mB40": `ProblemDetailsPopup-module__m-b-40___GkKc3`,
	"mT2": `ProblemDetailsPopup-module__m-t-2___MkW_J`,
	"mT3": `ProblemDetailsPopup-module__m-t-3___KC9x3`,
	"mT4": `ProblemDetailsPopup-module__m-t-4___yGzAh`,
	"mT5": `ProblemDetailsPopup-module__m-t-5___VNJa7`,
	"mT8": `ProblemDetailsPopup-module__m-t-8___oMkG5`,
	"mT10": `ProblemDetailsPopup-module__m-t-10___HV_YS`,
	"mT15": `ProblemDetailsPopup-module__m-t-15___Yx_YU`,
	"mT16": `ProblemDetailsPopup-module__m-t-16___KkJ_o`,
	"mT20": `ProblemDetailsPopup-module__m-t-20___wCynX`,
	"mT22": `ProblemDetailsPopup-module__m-t-22___Qy0Ln`,
	"mT30": `ProblemDetailsPopup-module__m-t-30___cMGP8`,
	"mT32": `ProblemDetailsPopup-module__m-t-32___qz7xU`,
	"mLAuto": `ProblemDetailsPopup-module__m-l-auto___tVM0q`,
	"mL4": `ProblemDetailsPopup-module__m-l-4___WxsHu`,
	"mL5": `ProblemDetailsPopup-module__m-l-5____Fsi4`,
	"mL6": `ProblemDetailsPopup-module__m-l-6___bGtWM`,
	"mL8": `ProblemDetailsPopup-module__m-l-8___LHKeP`,
	"mL10": `ProblemDetailsPopup-module__m-l-10___HRq_4`,
	"mL16": `ProblemDetailsPopup-module__m-l-16___rsvAv`,
	"mL20": `ProblemDetailsPopup-module__m-l-20___sVHsX`,
	"mL24": `ProblemDetailsPopup-module__m-l-24___BGAKc`,
	"mL30": `ProblemDetailsPopup-module__m-l-30___XCu2U`,
	"mL35": `ProblemDetailsPopup-module__m-l-35___Ywg4l`,
	"mL40": `ProblemDetailsPopup-module__m-l-40___Dc4Cc`,
	"mR8": `ProblemDetailsPopup-module__m-r-8___gsIe3`,
	"mR10": `ProblemDetailsPopup-module__m-r-10___mYjly`,
	"mR16": `ProblemDetailsPopup-module__m-r-16___Q2_jH`,
	"mR20": `ProblemDetailsPopup-module__m-r-20___FylX_`,
	"mR24": `ProblemDetailsPopup-module__m-r-24___rKRd0`,
	"mR30": `ProblemDetailsPopup-module__m-r-30___hP4GF`,
	"mR40": `ProblemDetailsPopup-module__m-r-40____N6Ni`,
	"borderR3": `ProblemDetailsPopup-module__border-r-3___CiyWF`,
	"borderR4": `ProblemDetailsPopup-module__border-r-4___uiDCJ`,
	"borderR6": `ProblemDetailsPopup-module__border-r-6___TLLDh`,
	"borderR10": `ProblemDetailsPopup-module__border-r-10___UFtAd`,
	"borderR12": `ProblemDetailsPopup-module__border-r-12___gx776`,
	"borderR16": `ProblemDetailsPopup-module__border-r-16___jWrFG`,
	"borderR50": `ProblemDetailsPopup-module__border-r-50___wF7QM`,
	"primaryBorder": `ProblemDetailsPopup-module__primary-border___arrr9`,
	"primaryBorderB": `ProblemDetailsPopup-module__primary-border-b___HdKm5`,
	"primaryBorderT": `ProblemDetailsPopup-module__primary-border-t___EMIvD`,
	"primaryBorderL": `ProblemDetailsPopup-module__primary-border-l____g1Se`,
	"primaryBorderR": `ProblemDetailsPopup-module__primary-border-r___TYQSd`,
	"secondaryBorder": `ProblemDetailsPopup-module__secondary-border___Pp3Md`,
	"secondaryBorderB": `ProblemDetailsPopup-module__secondary-border-b___OVJ6U`,
	"secondaryBorderT": `ProblemDetailsPopup-module__secondary-border-t___NqKca`,
	"secondaryBorderL": `ProblemDetailsPopup-module__secondary-border-l___o2pGW`,
	"secondaryBorderR": `ProblemDetailsPopup-module__secondary-border-r___YFpi6`,
	"gap0": `ProblemDetailsPopup-module__gap-0___G0BGs`,
	"gap2": `ProblemDetailsPopup-module__gap-2___nY0uU`,
	"gap4": `ProblemDetailsPopup-module__gap-4___A5DbK`,
	"gap5": `ProblemDetailsPopup-module__gap-5___JkVk_`,
	"gap6": `ProblemDetailsPopup-module__gap-6___WvqHk`,
	"gap8": `ProblemDetailsPopup-module__gap-8___q1wJA`,
	"gap10": `ProblemDetailsPopup-module__gap-10___msx_P`,
	"gap12": `ProblemDetailsPopup-module__gap-12___fwNwh`,
	"gap14": `ProblemDetailsPopup-module__gap-14___uIYD4`,
	"gap16": `ProblemDetailsPopup-module__gap-16___Nqqz8`,
	"gap18": `ProblemDetailsPopup-module__gap-18___zysHP`,
	"gap20": `ProblemDetailsPopup-module__gap-20___PGdK6`,
	"gap24": `ProblemDetailsPopup-module__gap-24___c7FL1`,
	"gap26": `ProblemDetailsPopup-module__gap-26___Bcqv_`,
	"gap30": `ProblemDetailsPopup-module__gap-30___BWFSP`,
	"gap32": `ProblemDetailsPopup-module__gap-32___pjqYm`,
	"gap40": `ProblemDetailsPopup-module__gap-40___J1NWl`,
	"gap50": `ProblemDetailsPopup-module__gap-50___U7ddj`,
	"flex1": `ProblemDetailsPopup-module__flex-1___lS0bQ`,
	"flexNone": `ProblemDetailsPopup-module__flex-none___FH5_o`,
	"flexColumn": `ProblemDetailsPopup-module__flex-column___CkW7y`,
	"flexRow": `ProblemDetailsPopup-module__flex-row___LGGHX`,
	"verticallyCentered": `ProblemDetailsPopup-module__vertically-centered___iOlp9`,
	"horizontallyCentered": `ProblemDetailsPopup-module__horizontally-centered___RVgV7`,
	"horizontallyEnd": `ProblemDetailsPopup-module__horizontally-end___FDjsz`,
	"verticallyStart": `ProblemDetailsPopup-module__vertically-start___r13O9`,
	"spaceBetween": `ProblemDetailsPopup-module__space-between___LOh00`,
	"flexWrap": `ProblemDetailsPopup-module__flex-wrap___I_pm9`,
	"height100": `ProblemDetailsPopup-module__height-100___yM5LZ`,
	"width50": `ProblemDetailsPopup-module__width-50___eXAQI`,
	"width100": `ProblemDetailsPopup-module__width-100___HOxfw`,
	"cursorPointer": `ProblemDetailsPopup-module__cursor-pointer___vN_WB`,
	"cursorNotAllowed": `ProblemDetailsPopup-module__cursor-not-allowed___hJWSk`,
	"absoluteCentered": `ProblemDetailsPopup-module__absolute-centered___biWBC`,
	"absolute": `ProblemDetailsPopup-module__absolute___n2fXu`,
	"relative": `ProblemDetailsPopup-module__relative___XbfDz`,
	"fixed": `ProblemDetailsPopup-module__fixed___OGIT_`,
	"visible": `ProblemDetailsPopup-module__visible___drTiW`,
	"invisible": `ProblemDetailsPopup-module__invisible___z0Iqv`,
	"col90": `ProblemDetailsPopup-module__col-90____eikw`,
	"colAuto": `ProblemDetailsPopup-module__col-auto___BDxHD`,
	"medicalTabs": `ProblemDetailsPopup-module__medical-tabs___wdscy`,
	"medicalTableNew": `ProblemDetailsPopup-module__medical-table-new___itCZ6`,
	"noPagination": `ProblemDetailsPopup-module__no-pagination___OWkPo`,
	"medicalTableEmpty": `ProblemDetailsPopup-module__medical-table-empty___OWjQX`,
	"iconBtn": `ProblemDetailsPopup-module__icon-btn___s8pu3`,
	"searchIcon": `ProblemDetailsPopup-module__search-icon___SbnLZ`,
	"disableSelect": `ProblemDetailsPopup-module__disable-select___VX6WJ`,
	"breakWord": `ProblemDetailsPopup-module__break-word___OmI88`,
	"popupClearBtn": `ProblemDetailsPopup-module__popup-clear-btn___emmdc`,
	"scrollMB20": `ProblemDetailsPopup-module__scroll-m-b-20___wxyG9`,
	"padding": `ProblemDetailsPopup-module__padding___LL3kf`,
	"itemsRow": `ProblemDetailsPopup-module__itemsRow___F_03h`,
	"item": `ProblemDetailsPopup-module__item___9kdRl`,
	"titleContainer": `ProblemDetailsPopup-module__titleContainer___Itx3g`,
	"textContainer": `ProblemDetailsPopup-module__textContainer___AugbP`,
	"titleText": `ProblemDetailsPopup-module__titleText___MIVcJ`,
	"icd10Text": `ProblemDetailsPopup-module__icd10Text___keXHz`,
	"separator": `ProblemDetailsPopup-module__separator___CKkVs`
};
module.exports = ___CSS_LOADER_EXPORT___;
